import type React from "react";
import { useNavigate } from "react-router";

import ImageParty from "@/assets/images/party.png";
import { Modal, type ModalBaseProps } from "@/components/Modal/Modal";
import { Button } from "@/design-system/Button";
import { Stack } from "@/design-system/Stack";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";
import { useTranslation } from "@/translations";

type SurveyRespondSuccessModalProps = ModalBaseProps & {
  message: string;
};

export function SurveyRespondSuccessModal({
  message,
  isOpened,
  onOpenChange,
}: SurveyRespondSuccessModalProps): React.ReactNode {
  const navigate = useNavigate();
  const slug = useSlug();
  const { t } = useTranslation();

  const handleClose = () => {
    void navigate(routes.communityFeed.list({ slug }));
  };

  return (
    <Modal.Root
      title={t("page.survey-respond.success-modal.title")}
      onOpenChange={(state) => {
        if (!state) {
          handleClose();
        }

        onOpenChange(state);
      }}
      data-testid="survey-respond-success-modal"
      {...{ isOpened }}
    >
      <Modal.Body>
        <Stack gap="md" align="center">
          <img className="my-space-lg w-illustration-compact" src={ImageParty} alt="success" />
          <p className="max-w-content-flow text-center text-body">{message}</p>
        </Stack>
      </Modal.Body>
      <Modal.Actions>
        <Modal.Close>
          <Button data-testid="survey-respond-success-modal-close-btn">
            {t("page.survey-respond.success-modal.button.continue")}
          </Button>
        </Modal.Close>
      </Modal.Actions>
    </Modal.Root>
  );
}
